import { render, staticRenderFns } from "./groupFormItem.vue?vue&type=template&id=4d6ced5b&scoped=true"
import script from "./groupFormItem.vue?vue&type=script&lang=js"
export * from "./groupFormItem.vue?vue&type=script&lang=js"
import style0 from "./groupFormItem.vue?vue&type=style&index=0&id=4d6ced5b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d6ced5b",
  null
  
)

export default component.exports